

















































































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { jzdx, yqxyy, SongGuo, ad, weMedia, qk } from '../../../../service/common'
import { finishTask, STAGES, STEPS } from '../../../../service/platform'
import { FinishTaskData, TaskInstance } from '../../types/task'
import { OperationMixin } from './OperationMixin'

const MODES = {
  LEVEL1_AUDIT: 'LEVEL1_AUDIT',
  LEVEL2_AUDIT: 'LEVEL2_AUDIT',
  CONTENT_MODIFY: 'CONTENT_MODIFY',
  JZDX_COMMENT_HANDLE: 'JZDX_COMMENT_HANDLE',
  YQXYY_ACTIVITY_HANDLE: 'YQXYY_ACTIVITY_HANDLE',
  SONGGUO_HANDLE: 'SONGGUO_HANDLE',
  AD_HANDLE: 'AD_HANDLE',
  WE_MEDIA_HANDLE: 'WE_MEDIA_HANDLE',
  QK_HANDLE: 'QK_HANDLE'
}

@Component
export default class HandleButtons extends Mixins(OperationMixin) {
  mounted() {
    console.log(this)
  }
  public get mode() {
    if (this.isJzdx) {
      return MODES.JZDX_COMMENT_HANDLE
    } else if (this.isSongguo) {
      return MODES.SONGGUO_HANDLE
    } else if (this.isYqxyy) {
      return MODES.YQXYY_ACTIVITY_HANDLE
    } else if (this.isAd) {
      return MODES.AD_HANDLE
    } else if (this.isWeMedia) {
      return MODES.WE_MEDIA_HANDLE
    } else if (
      STAGES.STAGE1.includes(this.data.process_id) &&
      ['1', '3'].includes(this.data.current_task.node_id)
    ) {
      return MODES.LEVEL1_AUDIT
    } else if (
      STAGES.STAGE2.includes(this.data.process_id) &&
      ['1', '3'].includes(this.data.current_task.node_id)
    ) {
      return MODES.LEVEL2_AUDIT
    } else if (
      [...STAGES.STAGE1, ...STAGES.STAGE2].includes(this.data.process_id) &&
      this.data.current_task.node_id == '2'
    ) {
      return MODES.CONTENT_MODIFY
    } else if (this.isQk) {
      return MODES.QK_HANDLE
    }
    return MODES.LEVEL1_AUDIT // should be unreachable
  }

  private get isSongguo() {
    // 判断是否是松果课堂
    return SongGuo.isSongguo(this.data)
  }

  private get isJzdx() {
    // 判断是否是家长大学的任务, 用来做特殊处理
    return jzdx.isJzdx(this.data)
  }
  private get isQk() {
    // 判断是否是家长大学的任务, 用来做特殊处理
    return qk.isQk(this.data)
  }
  private get isYqxyy() {
    // 判断是否是一起学运营的任务
    return yqxyy.isYqxyy(this.data)
  }

  private get isAd() {
    // 判断是否是广告
    return ad.isAd(this.data)
  }

  private get isWeMedia() {
    return weMedia.isWeMedia(this.data)
  }

  private get adMode() {
    if (
      STAGES.STAGE1.includes(this.data.process_id) &&
      ['1', '3'].includes(this.data.current_task.node_id)
    ) {
      return MODES.LEVEL1_AUDIT
    } else if (
      STAGES.STAGE2.includes(this.data.process_id) &&
      ['1', '3'].includes(this.data.current_task.node_id)
    ) {
      return MODES.LEVEL2_AUDIT
    } else if (
      [...STAGES.STAGE1, ...STAGES.STAGE2].includes(this.data.process_id) &&
      this.data.current_task.node_id == '2'
    ) {
      return MODES.CONTENT_MODIFY
    } else {
      return MODES.LEVEL1_AUDIT
    }
  }

  public async jzdxPass() {
    console.log('jzdxPass')
    this.getFinishTime({
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      step: 'deal_result'
    })
    const submitData: FinishTaskData = {
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      approve_result: 'PASS',
      approve_reason: '',
      variable_data_json: '',
      extra_operation_data_json: ''
    }
    let retData = await finishTask(submitData)
    if (retData.success) {
      this.close(true)
    }
  }

  public jzdxReject() {
    this.$emit('setLayout', 'jzdx-reject')
  }

  // 一起学运营 handler
  public async yqxyyPass() {
    this.$emit('setLayout', 'yqxyy-pass')
  }

  public yqxyyReject() {
    this.$emit('setLayout', 'yqxyy-reject')
  }

  // 松果 handler
  public async songguoPass() {
    this.$emit('setLayout', 'songguo-pass')
  }

  public songguoReject() {
    this.$emit('setLayout', 'songguo-reject')
  }

  // 广告 handler
  public async adPass() {
    this.$emit('setLayout', 'ad-pass')
  }
  public adReject() {
    this.$emit('setLayout', 'ad-reject')
  }
  // 自媒体 handler
  public async weMediaPass() {
    this.$emit('setLayout', 'we-media-pass')
  }
  public weMediaReject() {
    this.$emit('setLayout', 'we-media-reject')
  }
  // 轻课拒绝
  public qkReject() {
    this.$emit('setLayout', 'qk-reject')
  }
  // 图片审核相关
  // private get isImageReview() {
  //   // 判断是否是风控图片审核
  //   return true
  // }

  private imageReviewPass() {
    // TODO:
    // 行为同家长大学评论审核
    // this.jzdxPass()
    this.close(true)
  }

  private imageReviewReject() {
    this.$emit('setLayout', 'imageReivew-reject')
  }
  // 图片审核相关 END

  private pass() {
    console.log('LEVEL1_AUDIT')
    this.$emit('setLayout', 'pass')
  }

  private reject() {
    this.$emit('setLayout', 'reject')
  }

  private upgrade() {
    this.$emit('setLayout', 'upgrade')
  }

  private async modifyContent() {
    let submitData: FinishTaskData = {
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      approve_result: '',
      approve_reason: '',
      variable_data_json: '',
      extra_operation_data_json: ''
    }
    let retData = await finishTask(submitData)
    if (retData.success) {
      this.close(true)
    }
  }
  // 轻课通过
  private async qkPass() {
    this.getFinishTime({
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      step: 'deal_result'
    })
    let submitData: FinishTaskData = {
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      approve_result: 'PASS',
      approve_reason: '',
      variable_data_json: '',
      extra_operation_data_json: ''
    }
    let retData = await finishTask(submitData)
    if (retData.success) {
      this.close(true)
    }
  }
}
